import { styled } from '../../Utilities';
import { TooltipBase } from './Tooltip.base';
import { getStyles } from './Tooltip.styles';
export var Tooltip = styled(TooltipBase, getStyles, undefined, {
    scope: 'Tooltip',
});
//# sourceMappingURL=Tooltip.js.map